<template>
  <v-autocomplete
    v-model="VALOR_COMPUTED"
    :label="label[curva]"
    :items="items[curva]"
    v-bind="$attrs"
    v-bind:value="modelValue"
  >
    <template #prepend-item>
      <SysItemListaSelecionaTudo
        v-model="VALOR_COMPUTED"
        :itens="items[curva]"
        valor-chave="value"
      />
      <v-divider />
    </template>

    <template #selection="{ item }">
      <TextoOutrosFiltrosSelecionadosAutocomplete
        :filtros="VALOR_COMPUTED"
        :item="item"
        item_key="value"
        item_value="text"
        retornar_texto_completo
      />
    </template>
  </v-autocomplete>
</template>

<script>
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";
import TextoOutrosFiltrosSelecionadosAutocomplete from "@/components/Diagnostico/utils/TextoOutrosFiltrosSelecionadosAutocomplete.vue";

export default {
  name: "SysCurvasAutocomplete",
  components: {
    TextoOutrosFiltrosSelecionadosAutocomplete,
    SysItemListaSelecionaTudo,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: null,
    curva: {
      type: String,
      default: 'popularidade',
      validator(v) {
        return ['rentabilidade', 'popularidade', 'criticidade'].includes(v)
      },
    }
  },
  emits: ["update:modelValue"],
  data: () => ({
    items: {
      popularidade: [
        { value: 'P', text: '1. Frequência Alta de Saída' },
        { value: 'Q', text: '2. Frequência Média de Saída' },
        { value: 'R', text: '3. Frequência Baixa de Saída' },
      ],
      rentabilidade: [
        { value: 'A', text: '1. Frequência Alta de Saída' },
        { value: 'B', text: '2. Frequência Média de Saída' },
        { value: 'C', text: '3. Frequência Baixa de Saída' },
      ],
      criticidade: [
        { value: 'Z', text: '1. Frequência Alta de Saída' },
        { value: 'Y', text: '2. Frequência Média de Saída' },
        { value: 'X', text: '3. Frequência Baixa de Saída' },
      ],
    },
    label: {
      rentabilidade: "Curva Rentabilidade",
      popularidade: "Curva Popularidade",
      criticidade: "Curva Faturamento",
    }
  }),
  computed: {
    VALOR_COMPUTED: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit("update:modelValue", valor);
      }
    }
  }
}
</script>

